import React, { useState } from "react";
import "./header.css";
import FormatIndentIncreaseOutlinedIcon from "@mui/icons-material/FormatIndentIncreaseOutlined";
import MoveToInboxIcon from "@mui/icons-material/MoveToInbox";
import DashboardOutlinedIcon from "@mui/icons-material/DashboardOutlined";
import CategoryOutlinedIcon from "@mui/icons-material/CategoryOutlined";
import AccountBalanceOutlinedIcon from "@mui/icons-material/AccountBalanceOutlined";
import ShoppingCartOutlinedIcon from "@mui/icons-material/ShoppingCartOutlined";
import ReceiptOutlinedIcon from "@mui/icons-material/ReceiptOutlined";
import PeopleOutlinedIcon from "@mui/icons-material/PeopleOutlined";
import AssignmentOutlinedIcon from "@mui/icons-material/AssignmentOutlined";
import BarChartOutlinedIcon from "@mui/icons-material/BarChartOutlined";
import PersonOutlineOutlinedIcon from "@mui/icons-material/PersonOutlineOutlined";
import AddCircleIcon from "@mui/icons-material/AddCircle";
import HelpOutlineOutlinedIcon from "@mui/icons-material/HelpOutlineOutlined"; // Alternative for enquiry help
import GroupsOutlinedIcon from "@mui/icons-material/GroupsOutlined"; // For teams
import AccountCircleOutlinedIcon from "@mui/icons-material/AccountCircleOutlined"; // For CRM (customer/account representation)
import TimelineOutlinedIcon from "@mui/icons-material/TimelineOutlined"; // For tracking timelines
import InsertChartOutlinedIcon from "@mui/icons-material/InsertChartOutlined"; // For reports
import AssessmentOutlinedIcon from "@mui/icons-material/AssessmentOutlined"; // For detailed reporting
import TrendingUpOutlinedIcon from "@mui/icons-material/TrendingUpOutlined"; // For growth tracking
import TrackChangesOutlinedIcon from "@mui/icons-material/TrackChangesOutlined"; // For goal tracking
import DescriptionOutlinedIcon from "@mui/icons-material/DescriptionOutlined"; // For Documents
import LockOutlinedIcon from "@mui/icons-material/LockOutlined"; // For Password Manager
import { AiOutlineFile } from "react-icons/ai";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faFileInvoice, faUsers } from "@fortawesome/free-solid-svg-icons";
import OutboxIcon from "@mui/icons-material/Outbox";
class Mainmenu extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      mainActive: [
        false,
        false,
        false,
        false,
        false,
        false,
        false,
        false,
        false,
        false,
        false,
        false,
        false,
      ],
      blogActive: false,
      fMActive: false,
      color: true,
    };
  }

  componentDidMount() {
    const { navigation } = this.props;
    const activeKey = navigation.state.routes[navigation.state.index].key;
    if (activeKey === "dashboard") {
      var mA = [
        true,
        false,
        false,
        false,
        false,
        false,
        false,
        false,
        false,
        false,
        false,
        false,
        false,
      ];
      this.setState({
        mainActive: mA,
        blogActive: false,
        fMActive: true,
      });
    } else if (activeKey === "items" || activeKey === "ItemsNew") {
      var mA = [
        false,
        true,
        false,
        false,
        false,
        false,
        false,
        false,
        false,
        false,
        false,
        false,
        false,
      ];
      this.setState({
        blogActive: false,
        mainActive: mA,
        fMActive: false,
      });
    } else if (activeKey === "Enquiry" || activeKey === "EnquiryNew") {
      var mA = [
        false,
        false,
        true,
        false,
        false,
        false,
        false,
        false,
        false,
        false,
        false,
        false,
        false,
      ];
      this.setState({
        blogActive: false,
        mainActive: mA,
        fMActive: false,
      });
    } else if (
      activeKey === "bankacc" ||
      activeKey === "BankAccNew" ||
      activeKey === "calendar" ||
      activeKey === "contactList" ||
      activeKey === "contactCard" ||
      activeKey === "taskbar" ||
      activeKey === "NonInventory" ||
      activeKey === "ProductionStage" ||
      activeKey === "ProductCategory" ||
      activeKey === "Production"
    ) {
      var mA = [
        false,
        false,
        false,
        true,
        false,
        false,
        false,
        false,
        false,
        false,
        false,
        false,
        false,
      ];
      this.setState({
        mainActive: mA,
        blogActive: false,
        fMActive: false,
      });
    } else if (
      activeKey === "customers" ||
      activeKey === "Estimates" ||
      activeKey === "Order" ||
      activeKey === "Challans" ||
      activeKey == "Invoices" ||
      activeKey == "Payment" ||
      activeKey == "Credit" ||
      activeKey === "RecurringInvoices" ||
      activeKey === "CustomerNew" ||
      activeKey === "EstimatesNewButton" ||
      activeKey === "SalesOrderNewButton" ||
      activeKey === "DeliveryChallansNew" ||
      activeKey === "InvoicesNew" ||
      activeKey === "PaymentRecivedNew" ||
      activeKey === "CreditNoteNew" ||
      activeKey === "Proforma" ||
      activeKey === "quotes" ||
      activeKey === "quotesnew"
    ) {
      var mA = [
        false,
        false,
        false,
        false,
        true,
        false,
        false,
        false,
        false,
        false,
        false,
        false,
        false,
      ];
      this.setState({
        mainActive: mA,
        blogActive: false,
        fMActive: false,
      });
    } else if (
      activeKey === "vendors" ||
      activeKey === "VendorEnquiry" ||
      activeKey === "expenses" ||
      activeKey === "bills" ||
      activeKey === "ReceiptNote" ||
      activeKey === "purchaseOrder" ||
      activeKey === "EwayBills" ||
      activeKey === "EwayBillsNew" ||
      activeKey === "VendorsNew" ||
      activeKey === "AddVendorEnquiry" ||
      activeKey === "AddReceiptNote" ||
      activeKey === "ExpensesNew" ||
      activeKey === "BillsNew" ||
      activeKey === "PurchaseOrderNew"
    ) {
      var mA = [
        false,
        false,
        false,
        false,
        false,
        true,
        false,
        false,
        false,
        false,
        false,
        false,
        false,
      ];
      this.setState({
        mainActive: mA,
        blogActive: false,
        fMActive: false,
      });
    } else if (
      activeKey === "HRSEmployeeCard" ||
      activeKey === "HRSCandidateCard" ||
      activeKey === "TimeSheet" ||
      activeKey === "EmployeeLeaveCard"
    ) {
      var mA = [
        false,
        false,
        false,
        false,
        false,
        false,
        true,
        false,
        false,
        false,
        false,
        false,
        false,
      ];
      this.setState({
        mainActive: mA,
        blogActive: false,
        fMActive: false,
      });
    } else if (activeKey === "NewCampaign") {
      var mA = [
        false,
        false,
        false,
        false,
        false,
        false,
        false,
        true,
        false,
        false,
        false,
        false,
        false,
        false,
      ];
      this.setState({
        mainActive: mA,
        blogActive: false,
        fMActive: false,
      });
    } else if (activeKey === "Users") {
      var mA = [
        false,
        false,
        false,
        false,
        false,
        false,
        false,
        false,
        true,
        false,
        false,
        false,
        false,
      ];
      this.setState({
        mainActive: mA,
        blogActive: false,
        fMActive: false,
      });
    } else if (activeKey === "SalesPerson") {
      var mA = [
        false,
        false,
        false,
        false,
        false,
        false,
        false,
        false,
        false,
        true,
        false,
        false,
        false,
      ];
      this.setState({
        mainActive: mA,
        blogActive: false,
        fMActive: false,
      });
    } else if (activeKey === "GstFilling") {
      var mA = [
        false,
        false,
        false,
        false,
        false,
        false,
        false,
        false,
        false,
        false,
        false,
        true,
        false,
        false,
      ];
      this.setState({
        mainActive: mA,
        blogActive: false,
        fMActive: false,
      });
    } else if (activeKey === "reports") {
      var mA = [
        false,
        false,
        false,
        false,
        false,
        false,
        false,
        false,
        false,
        false,
        false,
        false,
        true,
        false,
      ];
      this.setState({
        mainActive: mA,
        blogActive: false,
        fMActive: false,
      });
    } else if (activeKey === "AppointmentCard") {
      var mA = [
        false,
        false,
        false,
        false,
        false,
        false,
        false,
        false,
        false,
        false,
        false,
        false,
        false,
        true,
        false,
      ];
      this.setState({
        mainActive: mA,
        blogActive: false,
        fMActive: false,
      });
    } else if (activeKey === "AppointmentCard") {
      var mA = [
        false,
        false,
        false,
        false,
        false,
        false,
        false,
        false,
        false,
        false,
        false,
        false,
        false,
        false,
        true,
      ];
      this.setState({
        mainActive: mA,
        blogActive: false,
        fMActive: false,
      });
    }
  }

  render() {
    const { navigation, apiData } = this.props;
    const { routeName } = navigation.state;
    const activeKey = navigation.state.routes[navigation.state.index].key;
    const { mainActive, blogActive, fMActive } = this.state;
    // const [light, setLight] = useState(true);
    const check = localStorage.getItem("check");
    const isTrue = mainActive[2] ? `active` : "" + "child-cont";

    const userRole = localStorage.getItem("userRole") || "user"; // Default to "user" if not found
    const isAdmin = userRole?.toLowerCase() === "admin"; // Check if user is Admin
    
    // If apiData is empty or undefined, show default menu items
    const menuData = apiData || { dashboard: "1" }; // At minimum, show dashboard

    const handle = () => {
      this.setState({ isToggle: !this.state.isToggle });
    };
    return (
      <div
        className="tab-pane active text"
        id="menu"
        style={{
          fontFamily: 'Inter, "Source Sans Pro", Helvetica, Arial, sans-serif',
          lineHeight: "26.8px",
          color: "rgb(24, 28, 46)",
        }}
      >
        <nav id="left-sidebar-nav text" className="sidebar-nav all text">
          <ul id="main-menu" className="metismenu li_animation_delay text">
            {/* Dashboard */}
            {(isAdmin || menuData.dashboard === "1") && (
              <li
                className={mainActive[0] ? "active" : ""}
                onClick={() => {
                  var mA = [
                    true,
                    false,
                    false,
                    false,
                    false,
                    false,
                    false,
                    false,
                    false,
                    false,
                    false,
                    false,
                  ];
                  if (!this.state.mainActive[0]) {
                    if (activeKey !== "dashboard" || mainActive[0] !== true) {
                      this.setState({
                        mainActive: mA,
                        blogActive: false,
                        fMActive: false,
                      });
                    } else {
                      this.setState({
                        mainActive: true,
                        blogActive: false,
                        fMActive: false,
                      });
                    }
                  }
                }}
              >
                <li
                  className={
                    activeKey === "dashboard" && mainActive[0] === true
                      ? "active"
                      : ""
                  }
                  onClick={() => {
                    if (activeKey !== "dashboard") {
                      navigation.navigate("dashboard");
                    }
                  }}
                >
                  <a href="#" className="pro active cont">
                    <DashboardOutlinedIcon />
                    <span className="ml-2">Dashboard</span>
                  </a>
                </li>
              </li>
            )}
            {(isAdmin || menuData.items === "1") && (
              <li
                className={mainActive[1] ? "active" : ""}
                onClick={() => {
                  var mA = [
                    false,
                    true,
                    false,
                    false,
                    false,
                    false,
                    false,
                    false,
                    false,
                    false,
                    false,
                    false,
                  ];

                  if (!this.state.mainActive[1]) {
                    if (activeKey !== "items" || "itemsNew") {
                      this.setState({
                        mainActive: mA,
                        blogActive: false,
                        fMActive: false,
                      });
                    } else {
                      this.setState({
                        mainActive: true,
                        blogActive: false,
                        fMActive: false,
                      });
                    }
                  }
                  // mA[0] = !this.state.mainActive[0];
                }}
              >
                <li
                  className={
                    (activeKey === "items" || "itemsNew") &&
                    mainActive[1] === true
                      ? "active"
                      : ""
                  }
                >
                  <a
                    href="#"
                    className=" pro active cont"
                    onClick={() => {
                      if (activeKey !== "items") {
                        navigation.navigate("items");
                      }
                    }}
                  >
                    <div className="cir">
                      <span className="pro">
                        {" "}
                        <CategoryOutlinedIcon />{" "}
                        <span className="ml-2">Items</span>
                      </span>
                      <span
                        className="circlehid"
                        onClick={() => {
                          if (activeKey !== "ItemsNew") {
                            navigation.navigate("ItemsNew");
                          }
                        }}
                      >
                        <AddCircleIcon className="circlechild" />
                      </span>
                    </div>
                  </a>
                </li>
              </li>
            )}
            {(isAdmin || menuData.enquiry === "1") && (
              <li
                className={mainActive[2] ? "active" : ""}
                onClick={() => {
                  var mA = [
                    false,
                    false,
                    true,
                    false,
                    false,
                    false,
                    false,
                    false,
                    false,
                    false,
                    false,
                    false,
                  ];

                  if (!this.state.mainActive[2]) {
                    if (activeKey !== "Enquiry" || "EnquiryNew") {
                      this.setState({
                        mainActive: mA,
                        blogActive: false,
                        fMActive: false,
                      });
                    } else {
                      this.setState({
                        mainActive: true,
                        blogActive: false,
                        fMActive: false,
                      });
                    }
                  }
                }}
              >
                <li
                  className={
                    (activeKey === "Enquiry" || "EnquiryNew") &&
                    mainActive[2] === true
                      ? "active"
                      : ""
                  }
                >
                  <a
                    href="#"
                    className=" pro active cont"
                    onClick={() => {
                      if (activeKey !== "Enquiry") {
                        navigation.navigate("Enquiry");
                      }
                    }}
                  >
                    <div className="cir">
                      <span className="pro">
                        {" "}
                        <HelpOutlineOutlinedIcon />{" "}
                        <span className="ml-2">Enquiry</span>
                      </span>
                      <span
                        className="circlehid"
                        onClick={() => {
                          if (activeKey !== "EnquiryNew") {
                            navigation.navigate("EnquiryNew");
                          }
                        }}
                      >
                        <AddCircleIcon className="circlechild" />
                      </span>
                    </div>
                  </a>
                </li>
              </li>
            )}

            {/* Banking */}
            {(isAdmin || menuData.banking === "1") && (
              <li className={mainActive[3] ? `active` : ""}>
                <a
                  href="#Banking"
                  className="text has-arrow active cont"
                  onClick={() => {
                    var mA = [
                      false,
                      false,
                      false,
                      true,
                      false,
                      false,
                      false,
                      false,
                      false,
                      false,
                      false,
                      false,
                    ];

                    mA[3] = !this.state.mainActive[3];

                    this.setState({
                      mainActive: mA,
                      blogActive: false,
                      fMActive: false,
                    });
                  }}
                >
                  <span className="pro">
                    <AccountBalanceOutlinedIcon />{" "}
                    <span className="ml-2">Banking</span>
                  </span>
                </a>
              </li>
            )}
            {(isAdmin || menuData.banking === "1") && (
              <ul
                aria-expanded="false"
                className={mainActive[3] ? `collapse in ` : "collapse"}
              >
                <li
                  className={
                    activeKey === "bankacc" || activeKey === "BankAccNew"
                      ? `active`
                      : "" + "child-cont"
                  }
                  onClick={(e) => {
                    e.preventDefault();
                    if (activeKey !== "bankacc") {
                      navigation.navigate("bankacc");
                    }
                  }}
                >
                  <a href="#" className="text pro">
                    <div className="cir">
                      <span className="pro"> Bank Account </span>
                      <span
                        className="circlehid"
                        onClick={() => {
                          if (activeKey !== "BankAccNew") {
                            navigation.navigate("BankAccNew");
                          }
                        }}
                      >
                        <AddCircleIcon className="circlechild" />
                      </span>
                    </div>
                  </a>
                </li>

                {/* <li
                  className={
                    activeKey === "NonInventory" || activeKey === "AddNonInventory"
                      ? `active`
                      : "" + "child-cont"
                  }
                  onClick={(e) => {
                    e.preventDefault();
                    if (activeKey !== "NonInventory") {
                      navigation.navigate("NonInventory");
                    }
                  }}
                >
                  <a href="#" className="text pro">
                    <div className="cir">
                      <span className="pro"> Non Inventory</span>
                      <span
                        className="circlehid"
                        onClick={() => {
                          if (activeKey !== "NonInventory") {
                            navigation.navigate("NonInventory");
                          }
                        }}
                      >
                        <AddCircleIcon className="circlechild" />
                      </span>
                    </div>
                  </a>
                </li> */}

                {/* <li
                  className={
                    activeKey === "ProductionStage" || activeKey === "AddProductionStage"
                      ? `active`
                      : "" + "child-cont"
                  }
                  onClick={(e) => {
                    e.preventDefault();
                    if (activeKey !== "ProductionStage") {
                      navigation.navigate("ProductionStage");
                    }
                  }}
                >
                  <a href="#" className="text pro">
                    <div className="cir">
                      <span className="pro"> Production Stage</span>
                      <span
                        className="circlehid"
                        onClick={() => {
                          if (activeKey !== "ProductionStage") {
                            navigation.navigate("ProductionStage");
                          }
                        }}
                      >
                        <AddCircleIcon className="circlechild" />
                      </span>
                    </div>
                  </a>
                </li> */}

                {/* <li
                  className={
                    activeKey === "ProductCategory" || activeKey === "AddProductCategory"
                      ? `active`
                      : "" + "child-cont"
                  }
                  onClick={(e) => {
                    e.preventDefault();
                    if (activeKey !== "ProductCategory") {
                      navigation.navigate("ProductCategory");
                    }
                  }}
                >
                  <a href="#" className="text pro">
                    <div className="cir">
                      <span className="pro"> Product Category</span>
                      <span
                        className="circlehid"
                        onClick={() => {
                          if (activeKey !== "ProductCategory") {
                            navigation.navigate("ProductCategory");
                          }
                        }}
                      >
                        <AddCircleIcon className="circlechild" />
                      </span>
                    </div>
                  </a>
                </li> */}

                {/* <li
                  className={
                    activeKey === "Production" || activeKey === "AddProduction"
                      ? `active`
                      : "" + "child-cont"
                  }
                  onClick={(e) => {
                    e.preventDefault();
                    if (activeKey !== "Production") {
                      navigation.navigate("Production");
                    }
                  }}
                >
                  <a href="#" className="text pro">
                    <div className="cir">
                      <span className="pro"> Production</span>
                      <span
                        className="circlehid"
                        onClick={() => {
                          if (activeKey !== "Production") {
                            navigation.navigate("Production");
                          }
                        }}
                      >
                        <AddCircleIcon className="circlechild" />
                      </span>
                    </div>
                  </a>
                </li> */}
              </ul>
            )}

            {(isAdmin || menuData.sales === "1") && (
              <li className={mainActive[4] ? "active" : ""}>
                <a
                  href="#Sales"
                  className="text has-arrow cont"
                  onClick={() => {
                    var mA = [
                      false,
                      false,
                      false,
                      false,
                      true,
                      false,
                      false,
                      false,
                      false,
                      false,
                      false,
                      false,
                    ];
                    mA[4] = !this.state.mainActive[4];
                    this.setState({
                      mainActive: mA,
                      blogActive: false,
                      fMActive: false,
                    });
                  }}
                >
                  <span className="pro">
                    {" "}
                    <ShoppingCartOutlinedIcon />{" "}
                    <span className="ml-2">Sales</span>
                  </span>
                </a>
              </li>
            )}
            {(isAdmin || menuData.sales === "1") && (
              <ul
                aria-expanded="false"
                className={mainActive[4] ? "collapse in" : "collapse"}
                id="stacked-menu"
                style={{}}
              >
                {(isAdmin || menuData.customer === "1") && (
                  <li
                    className={
                      activeKey === "Customers" || activeKey === "CustomerNew"
                        ? "active"
                        : "" + "child-cont"
                    }
                    onClick={() => {
                      if (activeKey !== "Customers") {
                        navigation.navigate("Customers");
                      }
                    }}
                  >
                    <a href="#" className="text pro">
                      <div className={"cir"}>
                        <span className="pro"> Customers</span>{" "}
                        <span
                          className="circlehid"
                          onClick={() => {
                            if (activeKey !== "CustomerNew") {
                              navigation.navigate("CustomerNew");
                            }
                          }}
                        >
                          <AddCircleIcon className="circlechild" />
                        </span>
                      </div>
                    </a>
                  </li>
                )}
                {(isAdmin || menuData.estimates === "1") && (
                  <li
                    className={
                      activeKey === "Estimates" ||
                      activeKey === "EstimatesNewButton"
                        ? "active"
                        : "" + "child-cont"
                    }
                    onClick={() => {
                      if (activeKey !== "Estimates") {
                        navigation.navigate("Estimates");
                      }
                    }}
                  >
                    <a href="#" className="text pro">
                      <div className={"cir"}>
                        <span className="pro"> Estimates</span>{" "}
                        <span
                          className="circlehid"
                          onClick={() => {
                            if (activeKey !== "EstimatesNewButton") {
                              navigation.navigate("EstimatesNewButton");
                            }
                          }}
                        >
                          <AddCircleIcon className="circlechild" />
                        </span>{" "}
                      </div>
                    </a>
                  </li>
                )}
                {(isAdmin || menuData.salesOrders === "1") && (
                  <li
                    className={
                      activeKey === "Order" ||
                      activeKey === "SalesOrderNewButton"
                        ? "active"
                        : "" + "child-cont"
                    }
                    onClick={() => {
                      if (activeKey !== "Order") {
                        navigation.navigate("Order");
                      }
                    }}
                  >
                    <a href="#" className="text pro">
                      <div className="cir">
                        <span className="pro"> Sales Orders</span>{" "}
                        <span
                          className="circlehid"
                          onClick={() => {
                            if (activeKey !== "SalesOrderNewButton") {
                              navigation.navigate("SalesOrderNewButton");
                            }
                          }}
                        >
                          {" "}
                          <AddCircleIcon className="circlechild" />
                        </span>{" "}
                      </div>
                    </a>
                  </li>
                )}
                {(isAdmin || menuData.deliveryChallans === "1") && (
                  <li
                    className={
                      activeKey === "Challans" ||
                      activeKey === "DeliveryChallansNew"
                        ? "active"
                        : "" + "child-cont"
                    }
                    onClick={() => {
                      if (activeKey !== "Challans") {
                        navigation.navigate("Challans");
                      }
                    }}
                  >
                    <a href="#" className="text pro">
                      <div className="cir">
                        <span className="pro"> Delivery Note</span>{" "}
                        <span
                          className="circlehid"
                          onClick={() => {
                            if (activeKey !== "DeliveryChallansNew") {
                              navigation.navigate("DeliveryChallansNew");
                            }
                          }}
                        >
                          <AddCircleIcon className="circlechild" />
                        </span>{" "}
                      </div>
                    </a>
                  </li>
                )}
                {(isAdmin || menuData.invoice === "1") && (
                  <li
                    className={
                      activeKey === "Invoices" || activeKey === "InvoicesNew"
                        ? "active"
                        : "" + "child-cont"
                    }
                    onClick={() => {
                      if (activeKey !== "Invoices") {
                        navigation.navigate("Invoices");
                      }
                    }}
                  >
                    <a href="#" className="text pro">
                      <div className="cir">
                        <span className="pro">Invoices</span>
                        <span
                          className="circlehid"
                          onClick={() => {
                            if (activeKey !== "InvoicesNew") {
                              navigation.navigate("InvoicesNew");
                            }
                          }}
                        >
                          <AddCircleIcon className="circlechild" />
                        </span>{" "}
                      </div>
                    </a>
                  </li>
                )}
                {(isAdmin || menuData.proFroma === "1") && (
                  <li
                    className={
                      activeKey === "Proforma" || activeKey === "ProformaNew"
                        ? "active"
                        : "" + "child-cont"
                    }
                    onClick={() => {
                      if (activeKey !== "Proforma") {
                        navigation.navigate("Proforma");
                      }
                    }}
                  >
                    <a href="#" className="text pro">
                      <div className="cir">
                        <span className="pro">Pro Forma</span>
                        <span
                          className="circlehid"
                          onClick={() => {
                            if (activeKey !== "ProformaNew") {
                              navigation.navigate("ProformaNew");
                            }
                          }}
                        >
                          <AddCircleIcon className="circlechild" />
                        </span>{" "}
                      </div>
                    </a>
                  </li>
                )}
                {(isAdmin || menuData.recurringInvoice === "1") && (
                  <li
                    className={
                      activeKey === "RecurringInvoices" ||
                      activeKey === "RecurringInvoiceNew"
                        ? "active"
                        : "" + "child-cont"
                    }
                    onClick={() => {
                      if (activeKey !== "RecurringInvoices") {
                        navigation.navigate("RecurringInvoices");
                      }
                    }}
                  >
                    <a href="#" className="text pro">
                      <div className="cir">
                        <span className="pro">Recurring Invoices</span>{" "}
                        <span
                          className="circlehid"
                          onClick={() => {
                            if (activeKey !== "RecurringInvoiceNew") {
                              navigation.navigate("RecurringInvoiceNew");
                            }
                          }}
                        >
                          <AddCircleIcon className="circlechild" />
                        </span>{" "}
                      </div>
                    </a>
                  </li>
                )}
                {(isAdmin || menuData.paymentReceived === "1") && (
                  <li
                    className={
                      activeKey === "Payment" ||
                      activeKey === "PaymentRecivedNew"
                        ? "active"
                        : "" + "child-cont"
                    }
                    onClick={() => {
                      if (activeKey !== "Payment") {
                        navigation.navigate("Payment");
                      }
                    }}
                  >
                    <a href="#" className="text pro">
                      <div className="cir">
                        <span className="pro">Payment Received</span>{" "}
                        <span
                          className="circlehid"
                          onClick={() => {
                            if (activeKey !== "PaymentRecivedNew") {
                              navigation.navigate("PaymentRecivedNew");
                            }
                          }}
                        >
                          <AddCircleIcon className="circlechild" />
                        </span>
                      </div>
                    </a>
                  </li>
                )}
                {(isAdmin || menuData.creditNotes === "1") && (
                  <li
                    className={
                      activeKey === "Credit" || activeKey === "CreditNoteNew"
                        ? "active"
                        : "" + "child-cont"
                    }
                    onClick={() => {
                      if (activeKey !== "Credit") {
                        navigation.navigate("Credit");
                      }
                    }}
                  >
                    <a href="#" className="text pro">
                      <div className="cir">
                        <span className="pro"> Credit Notes</span>{" "}
                        <span
                          className="circlehid"
                          onClick={() => {
                            if (activeKey !== "CreditNoteNew") {
                              navigation.navigate("CreditNoteNew");
                            }
                          }}
                        >
                          <AddCircleIcon className="circlechild" />
                        </span>{" "}
                      </div>
                    </a>
                  </li>
                )}
                {(isAdmin || menuData.quotation === "1") && (
                  <li
                    className={
                      activeKey === "quotes" || activeKey === "quotesnew"
                        ? "active"
                        : "" + "child-cont"
                    }
                    onClick={() => {
                      if (activeKey !== "quotes") {
                        navigation.navigate("quotes");
                      }
                    }}
                  >
                    <a href="#" className="text pro">
                      <div className="cir">
                        <span className="pro">Quotations</span>{" "}
                        <span
                          className="circlehid"
                          onClick={() => {
                            if (activeKey !== "quotesnew") {
                              navigation.navigate("quotesnew");
                            }
                          }}
                        >
                          <AddCircleIcon className="circlechild" />
                        </span>{" "}
                      </div>
                    </a>
                  </li>
                )}
              </ul>
            )}
            {(isAdmin || menuData.purchase === "1") && (
              <li className={mainActive[5] ? `active` : ""}>
                <a
                  href="#Purchases"
                  className="text has-arrow cont"
                  onClick={() => {
                    var mA = [
                      false,
                      false,
                      false,
                      false,
                      false,
                      true,
                      false,
                      false,
                      false,
                      false,
                      false,
                      false,
                    ];
                    mA[5] = !this.state.mainActive[5];
                    this.setState({
                      mainActive: mA,
                      blogActive: false,
                      fMActive: false,
                    });
                  }}
                >
                  <span className="pro">
                    {" "}
                    <ReceiptOutlinedIcon />{" "}
                    <span className="ml-2">Purchase</span>
                  </span>
                </a>
              </li>
            )}
            {(isAdmin || menuData.purchase === "1") && (
              <ul
                aria-expanded="false"
                className={mainActive[5] ? `collapse in` : "collapse"}
              >
                {(isAdmin || menuData.vendors === "1") && (
                  <li
                    className={
                      activeKey === "vendors" || activeKey === "VendorsNew"
                        ? `active`
                        : "" + "child-cont"
                    }
                    onClick={() => {
                      if (activeKey !== "vendors") {
                        navigation.navigate("vendors");
                      }
                    }}
                  >
                    <a href="#" className="text pro">
                      <div className="cir">
                        <span className="pro">Vendors</span>{" "}
                        <span
                          className="circlehid"
                          onClick={() => {
                            if (activeKey !== "VendorsNew") {
                              navigation.navigate("VendorsNew");
                            }
                          }}
                        >
                          <AddCircleIcon className="circlechild" />
                        </span>
                      </div>
                    </a>
                  </li>
                )}
                <li
                  className={
                    activeKey === "VendorEnquiry" ||
                    activeKey === "AddVendorEnquiry"
                      ? `active`
                      : "" + "child-cont"
                  }
                  onClick={() => {
                    if (activeKey !== "vendorEnquiry") {
                      navigation.navigate("VendorEnquiry");
                    }
                  }}
                >
                  <a href="#" className="text pro">
                    <div className="cir">
                      <span className="pro">Vendor Enquiry</span>{" "}
                      <span
                        className="circlehid"
                        onClick={() => {
                          if (activeKey !== "AddVendorEnquiry") {
                            navigation.navigate("AddVendorEnquiry");
                          }
                        }}
                      >
                        <AddCircleIcon className="circlechild" />
                      </span>
                    </div>
                  </a>
                </li>
                {(isAdmin || menuData.expenses === "1") && (
                  <li
                    className={
                      activeKey === "expenses" || activeKey === "ExpensesNew"
                        ? `active`
                        : "" + "child-cont"
                    }
                    onClick={() => {
                      if (activeKey !== "expenses") {
                        navigation.navigate("expenses");
                      }
                    }}
                  >
                    <a href="#" className="text pro">
                      <div className="cir">
                        <span className="pro">Expenses</span>{" "}
                        <span
                          className="circlehid"
                          onClick={() => {
                            if (activeKey !== "ExpensesNew") {
                              navigation.navigate("ExpensesNew");
                            }
                          }}
                        >
                          <AddCircleIcon className="circlechild" />
                        </span>{" "}
                      </div>
                    </a>
                  </li>
                )}
                {(isAdmin || menuData.bills === "1") && (
                  <li
                    className={
                      activeKey === "bills" || activeKey === "BillsNew"
                        ? `active`
                        : "" + "child-cont"
                    }
                    onClick={() => {
                      if (activeKey !== "bills") {
                        navigation.navigate("bills");
                      }
                    }}
                  >
                    <a href="#" className="text pro">
                      <div className="cir">
                        <span className="pro">Bills</span>{" "}
                        <span
                          className="circlehid"
                          onClick={() => {
                            if (activeKey !== "BillsNew") {
                              navigation.navigate("BillsNew");
                            }
                          }}
                        >
                          <AddCircleIcon className="circlechild" />
                        </span>{" "}
                      </div>
                    </a>
                  </li>
                )}
                <li
                  className={
                    activeKey === "ReceiptNote" ||
                    activeKey === "AddReceiptNote"
                      ? `active`
                      : "" + "child-cont"
                  }
                  onClick={() => {
                    if (activeKey !== "ReceiptNote") {
                      navigation.navigate("ReceiptNote");
                    }
                  }}
                >
                  <a href="#" className="text pro">
                    <div className="cir">
                      <span className="pro">Receipt Note</span>{" "}
                      <span
                        className="circlehid"
                        onClick={() => {
                          if (activeKey !== "AddReceiptNote") {
                            navigation.navigate("AddReceiptNote");
                          }
                        }}
                      >
                        <AddCircleIcon className="circlechild" />
                      </span>
                    </div>
                  </a>
                </li>
                {(isAdmin || menuData.purchaseOrder === "1") && (
                  <li
                    className={
                      activeKey === "purchaseOrder" ||
                      activeKey === "PurchaseOrderNew"
                        ? `active`
                        : "" + "child-cont"
                    }
                    onClick={() => {
                      if (activeKey !== "purchaseOrder") {
                        navigation.navigate("purchaseOrder");
                      }
                    }}
                  >
                    <a href="#" className="text pro">
                      <div className="cir">
                        <span className="pro">Purchase Order</span>{" "}
                        <span
                          className="circlehid"
                          onClick={() => {
                            if (activeKey !== "PurchaseOrderNew") {
                              navigation.navigate("PurchaseOrderNew");
                            }
                          }}
                        >
                          <AddCircleIcon className="circlechild" />
                        </span>{" "}
                      </div>
                    </a>
                  </li>
                )}
                {(isAdmin || menuData.paymentMade === "1") && (
                  <li
                    className={
                      activeKey === "paymentsMade" ||
                      activeKey === "PaymentsMadeNew"
                        ? `active`
                        : "" + "child-cont"
                    }
                    onClick={() => {
                      if (activeKey !== "paymentsMade") {
                        navigation.navigate("paymentsMade");
                      }
                    }}
                  >
                    <a href="#" className="text pro">
                      <div className="cir">
                        <span className="pro">Payments Made</span>{" "}
                        <span
                          className="circlehid"
                          onClick={() => {
                            if (activeKey !== "PaymentsMadeNew") {
                              navigation.navigate("PaymentsMadeNew");
                            }
                          }}
                        >
                          {" "}
                          <AddCircleIcon className="circlechild" />
                        </span>{" "}
                      </div>
                    </a>
                  </li>
                )}
              </ul>
            )}
            {(isAdmin || menuData.hr === "1") && (
              <li className={mainActive[6] ? "active" : ""}>
                <a
                  href="#Hr"
                  className="text has-arrow cont"
                  onClick={() => {
                    var mA = [
                      false,
                      false,
                      false,
                      false,
                      false,
                      false,
                      true,
                      false,
                      false,
                      false,
                      false,
                      false,
                    ];
                    mA[6] = !this.state.mainActive[6];
                    this.setState({
                      mainActive: mA,
                      blogActive: false,
                      fMActive: false,
                    });
                  }}
                >
                  <span className="pro">
                    {" "}
                    <GroupsOutlinedIcon /> <span className="ml-2">HR</span>
                  </span>
                </a>
              </li>
            )}
            {(isAdmin || menuData.hr === "1") && (
              <ul
                aria-expanded="false"
                className={mainActive[6] ? `collapse in` : "collapse"}
              >
                {(isAdmin || menuData.hrsEmployee === "1") && (
                  <li
                    className={
                      activeKey === "HRSEmployeeCard" ||
                      activeKey === "HRSEmployee"
                        ? "active"
                        : "" + "child-cont"
                    }
                    onClick={() => {
                      if (activeKey !== "HRSEmployeeCard") {
                        navigation.navigate("HRSEmployeeCard");
                      }
                    }}
                  >
                    <a href="#" className="text pro">
                      <div className="cir">
                        <span className="pro">HRS Employee</span>{" "}
                        <span
                          className="circlehid"
                          onClick={() => {
                            if (activeKey !== "HRSEmployee") {
                              navigation.navigate("HRSEmployee");
                            }
                          }}
                        >
                          {" "}
                          <AddCircleIcon className="circlechild" />
                        </span>{" "}
                      </div>
                    </a>
                  </li>
                )}
                {(isAdmin || menuData.hrsCandidate === "1") && (
                  <li
                    className={
                      activeKey === "HRSCandidateCard" ||
                      activeKey === "HRSCandidateData"
                        ? "active"
                        : "" + "child-cont"
                    }
                    onClick={() => {
                      if (activeKey !== "HRSCandidateCard") {
                        navigation.navigate("HRSCandidateCard");
                      }
                    }}
                  >
                    <a href="#" className="text pro">
                      <div className="cir">
                        <span className="pro">HRS Candidate</span>{" "}
                        <span
                          className="circlehid"
                          onClick={() => {
                            if (activeKey !== "HRSCandidateData") {
                              navigation.navigate("HRSCandidateData");
                            }
                          }}
                        >
                          {" "}
                          <AddCircleIcon className="circlechild" />
                        </span>{" "}
                      </div>
                    </a>
                  </li>
                )}
                {(isAdmin || menuData.timeSheet === "1") && (
                  <li
                    className={
                      activeKey === "TimeSheet" ? "active" : "" + "child-cont"
                    }
                    onClick={() => {
                      if (activeKey !== "TimeSheet") {
                        navigation.navigate("TimeSheet");
                      }
                    }}
                  >
                    <a href="#" className="text pro">
                      <div className="cir">
                        <span className="pro">Time Sheet</span>{" "}
                      </div>
                    </a>
                  </li>
                )}
                {/* {(isAdmin || menuData.hrsEmployee === "1") && ( */}
                  <li
                    className={
                      activeKey === "EmployeeLeaveCard" ||
                      activeKey === "HRSEmployee"
                        ? "active"
                        : "" + "child-cont"
                    }
                    onClick={() => {
                      if (activeKey !== "EmployeeLeaveCard") {
                        navigation.navigate("EmployeeLeaveCard");
                      }
                    }}
                  >
                    <a href="#" className="text pro">
                      <div className="cir">
                        <span className="pro">Leave Management</span>{" "}
                        <span
                          className="circlehid"
                          onClick={() => {
                            if (activeKey !== "HRSEmployee") {
                              navigation.navigate("HRSEmployee");
                            }
                          }}
                        >
                          {" "}
                          <AddCircleIcon className="circlechild" />
                        </span>{" "}
                      </div>
                    </a>
                  </li>
                {/* )} */}
              </ul>
            )}
            {(isAdmin || menuData.crm === "1") && (
              <li className={mainActive[7] ? "active" : ""}>
                <a
                  href="#Crm"
                  className="text has-arrow cont"
                  onClick={() => {
                    var mA = [
                      false,
                      false,
                      false,
                      false,
                      false,
                      false,
                      false,
                      true,
                      false,
                      false,
                      false,
                      false,
                      false,
                    ];
                    mA[7] = !this.state.mainActive[7];
                    this.setState({
                      mainActive: mA,
                      blogActive: false,
                      fMActive: false,
                    });
                  }}
                >
                  <span className="pro">
                    {" "}
                    <AccountCircleOutlinedIcon />{" "}
                    <span className="ml-2">CRM</span>
                  </span>
                </a>
              </li>
            )}
            {(isAdmin || menuData.crm === "1") && (
              <ul
                aria-expanded="false"
                className={mainActive[7] ? `collapse in` : "collapse"}
              >
                <li
                  className={
                    activeKey === "CampaignCard" || activeKey === "NewCampaign"
                      ? "active"
                      : "" + "child-cont"
                  }
                  onClick={() => {
                    if (activeKey !== "CampaignCard") {
                      navigation.navigate("CampaignCard");
                    }
                  }}
                >
                  <a href="#" className="text pro">
                    <div className="cir">
                      <span className="pro">Campaign</span>{" "}
                      <span
                        className="circlehid"
                        onClick={() => {
                          if (activeKey !== "NewCampaign") {
                            navigation.navigate("NewCampaign");
                          }
                        }}
                      >
                        {" "}
                        <AddCircleIcon className="circlechild" />
                      </span>{" "}
                    </div>
                  </a>
                </li>
              </ul>
            )}
            {(isAdmin || menuData.cheque === "1") && (
              <li
                className={mainActive[8] ? "active" : ""}
                onClick={() => {
                  var mA = [
                    false,
                    false,
                    false,
                    false,
                    false,
                    false,
                    false,
                    false,
                    true,
                    false,
                    false,
                    false,
                    false,
                    false,
                    false,
                    false,
                    false,
                    false,
                  ];
                  // mA[10] = !this.state.mainActive[10];
                  if (!this.state.mainActive[8]) {
                    if (activeKey !== "Cheque" || mainActive[8] !== true) {
                      this.setState({
                        mainActive: mA,
                        blogActive: false,
                        fMActive: false,
                      });
                    } else {
                      this.setState({
                        mainActive: true,
                        blogActive: false,
                        fMActive: false,
                      });
                    }
                  }
                }}
              >
                <li
                  className={
                    (activeKey === "Cheque" || activeKey === "AddCheque") &&
                    mainActive[8] === true
                      ? "active"
                      : ""
                  }
                >
                  <a
                    href="#"
                    className="text cont"
                    onClick={() => {
                      if (activeKey !== "Cheque") {
                        navigation.navigate("Cheque");
                      }
                    }}
                  >
                    {" "}
                    <div className="cir">
                      <span className="pro">
                        {" "}
                        <InsertChartOutlinedIcon />{" "}
                        <span className="ml-2">Cheque</span>
                      </span>
                      <span
                        className="circlehid"
                        onClick={() => {
                          if (activeKey !== "AddCheque") {
                            navigation.navigate("AddCheque");
                          }
                        }}
                      >
                        {" "}
                        <AddCircleIcon className="circlechild" />
                      </span>{" "}
                    </div>
                  </a>
                </li>
              </li>
            )}
            {(isAdmin || menuData.passwordManager === "1") && (
              <li
                className={mainActive[9] ? "active" : ""}
                onClick={() => {
                  var mA = [
                    false,
                    false,
                    false,
                    false,
                    false,
                    false,
                    false,
                    false,
                    false,
                    true,
                    false,
                    false,
                    false,
                    false,
                    false,
                    false,
                    false,
                    false,
                  ];
                  // mA[10] = !this.state.mainActive[10];
                  if (!this.state.mainActive[9]) {
                    if (
                      activeKey !== "PasswordManager" ||
                      mainActive[9] !== true
                    ) {
                      this.setState({
                        mainActive: mA,
                        blogActive: false,
                        fMActive: false,
                      });
                    } else {
                      this.setState({
                        mainActive: true,
                        blogActive: false,
                        fMActive: false,
                      });
                    }
                  }
                }}
              >
                <li
                  className={
                    activeKey === "PasswordManager" ||
                    (activeKey === "AddPassword" && mainActive[9] === true)
                      ? "active"
                      : ""
                  }
                >
                  <a
                    href="#"
                    className="text cont"
                    onClick={() => {
                      if (activeKey !== "PasswordManager") {
                        navigation.navigate("PasswordManager");
                      }
                    }}
                  >
                    {" "}
                    <div className="cir">
                      <span className="pro">
                        {" "}
                        <LockOutlinedIcon />{" "}
                        <span className="ml-2">Password Manager</span>
                      </span>
                      <span
                        className="circlehid"
                        onClick={() => {
                          if (activeKey !== "AddPassword") {
                            navigation.navigate("AddPassword");
                          }
                        }}
                      >
                        {" "}
                        <AddCircleIcon className="circlechild" />
                      </span>{" "}
                    </div>
                  </a>
                </li>
              </li>
            )}
            {(isAdmin || menuData.appointments === "1") && (
              <li
                className={mainActive[14] ? "active" : ""}
                onClick={() => {
                  var mA = [
                    false,
                    false,
                    false,
                    false,
                    false,
                    false,
                    false,
                    false,
                    false,
                    false,
                    false,
                    false,
                    false,
                    false,
                    true,
                    false,
                    false,
                    false,
                  ];
                  // mA[10] = !this.state.mainActive[10];
                  if (!this.state.mainActive[14]) {
                    if (
                      activeKey !== "AppointmentCard" ||
                      mainActive[14] !== true
                    ) {
                      this.setState({
                        mainActive: mA,
                        blogActive: false,
                        fMActive: false,
                      });
                    } else {
                      this.setState({
                        mainActive: true,
                        blogActive: false,
                        fMActive: false,
                      });
                    }
                  }
                }}
              >
                <li
                  className={
                    activeKey === "AppointmentCard" ||
                    (activeKey === "NewAppointment" && mainActive[14] === true)
                      ? "active"
                      : ""
                  }
                >
                  <a
                    href="#"
                    className="text cont"
                    onClick={() => {
                      if (activeKey !== "AppointmentCard") {
                        navigation.navigate("AppointmentCard");
                      }
                    }}
                  >
                    {" "}
                    <div className="cir">
                      <span className="pro">
                        {" "}
                        <TimelineOutlinedIcon />{" "}
                        <span className="ml-2">Appointments</span>
                      </span>
                      <span
                        className="circlehid"
                        onClick={() => {
                          if (activeKey !== "NewAppointment") {
                            navigation.navigate("NewAppointment");
                          }
                        }}
                      >
                        {" "}
                        <AddCircleIcon className="circlechild" />
                      </span>{" "}
                    </div>
                  </a>
                </li>
              </li>
            )}
            {(isAdmin || menuData.indent === "1") && (
              <li
                className={mainActive[15] ? "active" : ""}
                onClick={() => {
                  var mA = [
                    false,
                    false,
                    false,
                    false,
                    false,
                    false,
                    false,
                    false,
                    false,
                    false,
                    false,
                    false,
                    false,
                    false,
                    false,
                    true,
                    false,
                    false,
                  ];
                  // mA[10] = !this.state.mainActive[10];
                  if (!this.state.mainActive[15]) {
                    if (activeKey !== "Indent" || mainActive[15] !== true) {
                      this.setState({
                        mainActive: mA,
                        blogActive: false,
                        fMActive: false,
                      });
                    } else {
                      this.setState({
                        mainActive: true,
                        blogActive: false,
                        fMActive: false,
                      });
                    }
                  }
                }}
              >
                <li
                  className={
                    activeKey === "Indent" ||
                    (activeKey === "NewIndent" && mainActive[15] === true)
                      ? "active"
                      : ""
                  }
                >
                  <a
                    href="#"
                    className="text cont"
                    onClick={() => {
                      if (activeKey !== "Indent") {
                        navigation.navigate("Indent");
                      }
                    }}
                  >
                    <div className="cir">
                      <span className="pro">
                        {" "}
                        <FormatIndentIncreaseOutlinedIcon />{" "}
                        <span className="ml-2">Indent</span>
                      </span>
                      <span
                        className="circlehid"
                        onClick={() => {
                          if (activeKey !== "NewIndent") {
                            navigation.navigate("NewIndent");
                          }
                        }}
                      >
                        {" "}
                        <AddCircleIcon className="circlechild" />
                      </span>{" "}
                    </div>
                  </a>
                </li>
              </li>
            )}

            {(isAdmin || menuData.inword === "1") && (
              <li
                className={mainActive[16] ? "active" : ""}
                onClick={() => {
                  var mA = [
                    false,
                    false,
                    false,
                    false,
                    false,
                    false,
                    false,
                    false,
                    false,
                    false,
                    false,
                    false,
                    false,
                    false,
                    false,
                    false,
                    true,
                    false,
                  ];
                  // mA[10] = !this.state.mainActive[10];
                  if (!this.state.mainActive[16]) {
                    if (activeKey !== "InWard" || mainActive[16] !== true) {
                      this.setState({
                        mainActive: mA,
                        blogActive: false,
                        fMActive: false,
                      });
                    } else {
                      this.setState({
                        mainActive: true,
                        blogActive: false,
                        fMActive: false,
                      });
                    }
                  }
                }}
              >
                <li
                  className={
                    activeKey === "InWard" ||
                    (activeKey === "NewInWard" && mainActive[16] === true)
                      ? "active"
                      : ""
                  }
                >
                  <a
                    href="#"
                    className="text cont"
                    onClick={() => {
                      if (activeKey !== "InWard") {
                        navigation.navigate("InWard");
                      }
                    }}
                  >
                    {" "}
                    <div className="cir">
                      <span className="pro">
                        {" "}
                        <MoveToInboxIcon /> <span className="ml-2">InWard</span>
                      </span>
                      <span
                        className="circlehid"
                        onClick={() => {
                          if (activeKey !== "NewInWard") {
                            navigation.navigate("NewInWard");
                          }
                        }}
                      >
                        {" "}
                        <AddCircleIcon className="circlechild" />
                      </span>{" "}
                    </div>
                  </a>
                </li>
              </li>
            )}
            {(isAdmin || menuData.outword === "1") && (
              <li
                className={mainActive[17] ? "active" : ""}
                onClick={() => {
                  var mA = [
                    false,
                    false,
                    false,
                    false,
                    false,
                    false,
                    false,
                    false,
                    false,
                    false,
                    false,
                    false,
                    false,
                    false,
                    false,
                    false,
                    false,
                    true,
                  ];
                  // mA[10] = !this.state.mainActive[10];
                  if (!this.state.mainActive[17]) {
                    if (activeKey !== "OutWard" || mainActive[17] !== true) {
                      this.setState({
                        mainActive: mA,
                        blogActive: false,
                        fMActive: false,
                      });
                    } else {
                      this.setState({
                        mainActive: true,
                        blogActive: false,
                        fMActive: false,
                      });
                    }
                  }
                }}
              >
                <li
                  className={
                    activeKey === "OutWard" ||
                    (activeKey === "NewOutWard" && mainActive[17] === true)
                      ? "active"
                      : ""
                  }
                >
                  <a
                    href="#"
                    className="text cont"
                    onClick={() => {
                      if (activeKey !== "OutWard") {
                        navigation.navigate("OutWard");
                      }
                    }}
                  >
                    {" "}
                    <div className="cir">
                      <span className="pro">
                        <OutboxIcon />
                        <span className="ml-2">OutWard</span>
                      </span>
                      <span
                        className="circlehid"
                        onClick={() => {
                          if (activeKey !== "NewOutWard") {
                            navigation.navigate("NewOutWard");
                          }
                        }}
                      >
                        {" "}
                        <AddCircleIcon className="circlechild" />
                      </span>{" "}
                    </div>
                  </a>
                </li>
              </li>
            )}
            {(isAdmin || menuData.documents === "1") && (
              <li
                className={mainActive[18] ? "active" : ""}
                onClick={() => {
                  var mA = [
                    false,
                    false,
                    false,
                    false,
                    false,
                    false,
                    false,
                    false,
                    false,
                    false,
                    false,
                    false,
                    false,
                    false,
                    false,
                    false,
                    false,
                    false,
                    true,
                  ];
                  // mA[10] = !this.state.mainActive[10];
                  if (!this.state.mainActive[18]) {
                    if (activeKey !== "Documents" || mainActive[18] !== true) {
                      this.setState({
                        mainActive: mA,
                        blogActive: false,
                        fMActive: false,
                      });
                    } else {
                      this.setState({
                        mainActive: true,
                        blogActive: false,
                        fMActive: false,
                      });
                    }
                  }
                }}
              >
                <li
                  className={
                    activeKey === "Documents" ||
                    (activeKey === "AddDocument" && mainActive[18] === true)
                      ? "active"
                      : ""
                  }
                >
                  <a
                    href="#"
                    className="text cont"
                    onClick={() => {
                      if (activeKey !== "Documents") {
                        navigation.navigate("Documents");
                      }
                    }}
                  >
                    {" "}
                    <div className="cir">
                      <span className="pro">
                        <DescriptionOutlinedIcon />
                        <span className="ml-2">Documents</span>
                      </span>
                      <span
                        className="circlehid"
                        onClick={() => {
                          if (activeKey !== "AddDocument") {
                            navigation.navigate("AddDocument");
                          }
                        }}
                      >
                        {" "}
                        <AddCircleIcon className="circlechild" />
                      </span>{" "}
                    </div>
                  </a>
                </li>
              </li>
            )}
            {(isAdmin || menuData.userAndRoles === "1") && (
              <li className={mainActive[19] ? "active" : ""}>
                <a
                  href="#Users"
                  className="text has-arrow cont"
                  onClick={() => {
                    var mA = [
                      false,
                      false,
                      false,
                      false,
                      false,
                      false,
                      false,
                      false,
                      false,
                      false,
                      false,
                      false,
                      false,
                      false,
                      false,
                      false,
                      false,
                      false,
                      false,
                      true,
                    ];
                    mA[19] = !this.state.mainActive[19];
                    this.setState({
                      mainActive: mA,
                      blogActive: false,
                      fMActive: false,
                    });
                  }}
                >
                  <span className="pro">
                    {" "}
                    <PeopleOutlinedIcon />{" "}
                    <span className="ml-2">Users & Roles</span>
                  </span>
                </a>
              </li>
            )}
            {(isAdmin || menuData.users === "1") && (
              <ul
                aria-expanded="false"
                className={mainActive[19] ? `collapse in` : "collapse"}
              >
                <li
                  className={
                    activeKey === "Users" ? "active" : "" + "child-cont"
                  }
                  onClick={() => {
                    if (activeKey !== "Users") {
                      navigation.navigate("Users");
                    }
                  }}
                >
                  <a href="#" className="text pro">
                    <div className="cir">
                      <span className="pro">Users</span>{" "}
                    </div>
                  </a>
                </li>
              </ul>
            )}
            <li
              className={mainActive[20] ? "active" : ""}
              onClick={() => {
                var mA = [
                  false,
                  false,
                  false,
                  false,
                  false,
                  false,
                  false,
                  false,
                  false,
                  false,
                  false,
                  false,
                  false,
                  false,
                  false,
                  false,
                  false,
                  false,
                  false,
                  false,
                  true,
                ];
                // mA[10] = !this.state.mainActive[10];
                if (!this.state.mainActive[20]) {
                  if (activeKey !== "GstFilling" || mainActive[20] !== true) {
                    this.setState({
                      mainActive: mA,
                      blogActive: false,
                      fMActive: false,
                    });
                  } else {
                    this.setState({
                      mainActive: true,
                      blogActive: false,
                      fMActive: false,
                    });
                  }
                }
              }}
            >
              {(isAdmin || menuData.manageSalesPerson === "1") && (
                <li
                  className={
                    activeKey === "SalesPerson" && mainActive[20] === true
                      ? "active"
                      : ""
                  }
                >
                  <a
                    href="#"
                    className="text cont"
                    onClick={() => {
                      if (activeKey !== "SalesPerson") {
                        navigation.navigate("SalesPerson");
                      }
                    }}
                  >
                    {" "}
                    <span className="pro">
                      {" "}
                      <PersonOutlineOutlinedIcon />{" "}
                      <span className="ml-2">Manage SalesPerson</span>
                    </span>
                  </a>
                </li>
              )}
            </li>
            {check === "YES" && (
              <li
                className={mainActive[21] ? "active" : ""}
                onClick={() => {
                  var mA = [
                    false,
                    false,
                    false,
                    false,
                    false,
                    false,
                    false,
                    false,
                    false,
                    false,
                    false,
                    true,
                    false,
                    false,
                    false,
                    false,
                  ];
                  // mA[10] = !this.state.mainActive[10];
                  if (!this.state.mainActive[21]) {
                    if (activeKey !== "GstFilling" || mainActive[21] !== true) {
                      this.setState({
                        mainActive: mA,
                        blogActive: false,
                        fMActive: false,
                      });
                    } else {
                      this.setState({
                        mainActive: true,
                        blogActive: false,
                        fMActive: false,
                      });
                    }
                  }
                }}
              >
                <li
                  className={
                    activeKey === "GstFilling" && mainActive[21] === true
                      ? "active"
                      : ""
                  }
                >
                  <a
                    href="#"
                    className="text cont"
                    onClick={() => {
                      if (activeKey !== "GstFilling") {
                        navigation.navigate("GstFilling");
                      }
                    }}
                  >
                    {" "}
                    <span className="pro">
                      {" "}
                      <AssignmentOutlinedIcon />{" "}
                      <span className="ml-2">GST Filling</span>
                    </span>
                  </a>
                </li>
              </li>
            )}

            {(isAdmin || menuData.reports === "1") && (
              <li
                className={mainActive[22] ? "active" : ""}
                onClick={() => {
                  var mA = [
                    false,
                    false,
                    false,
                    false,
                    false,
                    false,
                    false,
                    false,
                    false,
                    false,
                    false,
                    false,
                    false,
                    false,
                    false,
                    false,
                    false,
                    false,
                    false,
                    false,
                    false,
                    false,
                    true,
                  ];
                  // mA[10] = !this.state.mainActive[10];
                  if (!this.state.mainActive[22]) {
                    if (activeKey !== "reports" || mainActive[22] !== true) {
                      this.setState({
                        mainActive: mA,
                        blogActive: false,
                        fMActive: false,
                      });
                    } else {
                      this.setState({
                        mainActive: true,
                        blogActive: false,
                        fMActive: false,
                      });
                    }
                  }
                }}
              >
                <li
                  className={
                    activeKey === "reports" && mainActive[22] === true
                      ? "active"
                      : ""
                  }
                >
                  <a
                    href="#"
                    className="text cont"
                    onClick={() => {
                      if (activeKey !== "reports") {
                        navigation.navigate("reports");
                      }
                    }}
                  >
                    {" "}
                    <span className="pro">
                      {" "}
                      <BarChartOutlinedIcon />{" "}
                      <span className="ml-2">Reports</span>
                    </span>
                  </a>
                </li>
              </li>
            )}
          </ul>
        </nav>
      </div>
    );
  }
}
export default Mainmenu;
